import { FormRow, FormFieldBoxRoot } from "../../shared/practitionerForm.styles";
import { useAgePreferencesSelection } from "../hooks/useAgePreferencesSelection";
import {
  CustomDropdown,
  CustomMultiSelectDropdown,
} from "../../../Common/CustomDropdown";
import { colors } from "../../../../theme/theme";
import * as C from "../IPHCPractitionerModal.constants";
import { convertBooleanToString } from "../../shared/practitionerForm.utils";

const PreferencesSection = ({ submitData, updateField }) => {
  const handleAgePreferencesChange = useAgePreferencesSelection(
    submitData.agePreferences,
    updateField
  );

  return (
    <>
      <FormRow>
        {C.PREFERENCES_DROPDOWN_FIELDS.slice(0, 2).map((field) => (
          <FormFieldBoxRoot key={field.name}>
            <CustomDropdown
              label={field.label}
              value={
                field.convertValue
                  ? convertBooleanToString(submitData[field.name])
                  : submitData[field.name]
              }
              setValue={(value) => updateField(field.name, value)}
              placeholder={field.placeholder}
              data={C[field.dataKey]}
              noIcon
              color={colors.primary}
              width="100%"
            />
          </FormFieldBoxRoot>
        ))}
      </FormRow>
      <FormRow>
        <FormFieldBoxRoot>
          <CustomDropdown
            label={C.PREFERENCES_DROPDOWN_FIELDS[2].label}
            value={submitData.gender}
            setValue={(value) => updateField("gender", value)}
            placeholder={C.PREFERENCES_DROPDOWN_FIELDS[2].placeholder}
            data={C.GENDER_OPTIONS}
            noIcon
            color={colors.primary}
            width="100%"
          />
        </FormFieldBoxRoot>
        <FormFieldBoxRoot>
          <CustomMultiSelectDropdown
            label={C.PREFERENCES_AGE_FIELD.label}
            value={
              Array.isArray(submitData.agePreferences)
                ? submitData.agePreferences
                : []
            }
            setValue={handleAgePreferencesChange}
            placeholder={C.PREFERENCES_AGE_FIELD.placeholder}
            data={C.AGE_PREFERENCES_OPTIONS}
            noIcon
            color={colors.primary}
            width="100%"
          />
        </FormFieldBoxRoot>
      </FormRow>
    </>
  );
};

export default PreferencesSection;
